import { Tabs, TabsProps } from "antd";
import { List } from "@refinedev/antd";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { StadiumManagementShow } from "./Stadium-Management-Show/Stadium-Management-Show";
import { StadiumManagementDocsList } from "./StadiumManagementDocsList";

export function StadiumManagementPage() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const tabKey = searchParams.get("tab") || "content";

  const onChange = (key: string) => {
    navigate(
      { search: createSearchParams({ tab: key }).toString() },
      { replace: true }
    );
  };

  const items: TabsProps["items"] = [
    {
      key: "content",
      label: "Контент",
      children: <StadiumManagementShow />,
    },
    {
      key: "docs",
      label: "Документы",
      children: <StadiumManagementDocsList />,
    },
  ];

  return (
    <List
      title="Руководство по стадиону"
      resource={"stadium-management"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
    >
      <Tabs items={items} onChange={onChange} activeKey={tabKey} />
    </List>
  );
}
